/**
 * 회원 검색 팝업 컴포넌트
 * 회원을 검색하고 선택할 수 있는 팝업 컴포넌트입니다.
 */

import { BaseAbstractModal } from "src/components/BaseAbstractModal";
import TaapMemberFind from "../contract/commonComponents/modal/TaapMemberFind";

/**
 * 컴포넌트 Props 인터페이스
 * @param isOpen - 팝업 표시 여부
 * @param memberInfo - 회원 정보 (선택적)
 * @param onClick - 클릭 이벤트 핸들러 (선택적)
 * @param onClose - 닫기 이벤트 핸들러 (선택적)
 */
type Props = {
  isOpen: boolean;
  memberInfo?: any;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onClose?: React.MouseEventHandler<HTMLButtonElement>;
};

/**
 * 회원 검색 팝업 컴포넌트
 * @param props - 컴포넌트 Props
 */
const SearchMemberPopup = (props: Props) => {
  return (
    <div>
      <BaseAbstractModal size="medium" isOpen={props.isOpen}>
        <TaapMemberFind isOpen={props.isOpen} memberInfo={props.memberInfo} onClick={props.onClick} onClose={props.onClose} size={"medium"} />
      </BaseAbstractModal>
    </div>
  );
};

export default SearchMemberPopup;
